import { render, staticRenderFns } from "./CclPlayer.vue?vue&type=template&id=528e8647&scoped=true&"
import script from "./CclPlayer.vue?vue&type=script&lang=js&"
export * from "./CclPlayer.vue?vue&type=script&lang=js&"
import style0 from "./CclPlayer.vue?vue&type=style&index=0&id=528e8647&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e8647",
  null
  
)

export default component.exports